import React from 'react';
import { useParams } from 'react-router-dom';
import { detailedBlogPosts } from '../../content'; // Assuming detailed blog content is here

const BlogPost = () => {
  const { id } = useParams();
  const post = detailedBlogPosts.find((p) => p.id === parseInt(id));

  if (!post) {
    return (
      <div className="container mx-auto px-4 py-10 font-sans text-gray-800 text-center">
        <h1 className="text-4xl text-[#4a2c2a] mb-4">Blog Post Not Found</h1>
        <p className="text-lg">The blog post you are looking for does not exist.</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-10 font-sans text-gray-800 max-w-3xl">
      <h1 className="text-center text-5xl text-[#4a2c2a] mb-12 relative pb-4">
        {post.title}
        <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-20 h-1 bg-[#a0522d] rounded-md"></span>
      </h1>
      <img src={post.image} alt={post.title} className="w-full h-96 object-cover rounded-lg mb-8 shadow-md" />
      <p className="text-sm text-gray-600 mb-6 text-center">By {post.author} on {post.date}</p>
      <div className="prose lg:prose-lg mx-auto">
        {post.fullContent.map((paragraph, index) => (
          <p key={index} className="mb-4 text-lg leading-relaxed">{paragraph}</p>
        ))}
      </div>
      <div className="mt-12 text-center">
        <a href="/blog" className="inline-block bg-[#a0522d] text-white px-6 py-3 rounded-md font-bold transition-colors duration-300 hover:bg-[#8b4513]">Back to Blog</a>
      </div>
    </div>
  );
};

export default BlogPost;
